module.exports = "<div class=\"footer\"><div class=\"content\"><div class=\"head\">Elérhetőségek</div><div class=\"detail\"><span class=\"bold\">Cím:</span>1054 Budapest, Bajcsy-Zsilinszky út 52.<span class=\"bold\">Postacím:</span>1388 Budapest, Pf. 89<span class=\"bold\">Telefon:</span>+36 1 459 7777<span class=\"bold\">Fax:</span>+36 1 459 7766<span class=\"bold\">E-mail:</span><a href=\"mailto:mekh@mekh.hu\"><span class=\"email\">mekh@mekh.hu</span></a></div></div></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/footer/footer.component.pug
// module id = ./src/app/layout/footer/footer.component.pug
// module chunks = main